import React from "react";

function People() {
  return (
    <svg
      width="28"
      height="20"
      viewBox="0 0 28 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.125 8.36523C2.57812 8.36523 1.375 7.16211 1.375 5.61523C1.375 4.11133 2.57812 2.86523 4.125 2.86523C5.62891 2.86523 6.875 4.11133 6.875 5.61523C6.875 7.16211 5.62891 8.36523 4.125 8.36523ZM23.375 8.36523C21.8281 8.36523 20.625 7.16211 20.625 5.61523C20.625 4.11133 21.8281 2.86523 23.375 2.86523C24.8789 2.86523 26.125 4.11133 26.125 5.61523C26.125 7.16211 24.8789 8.36523 23.375 8.36523ZM24.75 9.74023C26.2539 9.74023 27.5 10.9863 27.5 12.4902V13.8652C27.5 14.6387 26.8555 15.2402 26.125 15.2402H23.2891C22.9883 13.2207 21.7852 11.502 20.0234 10.5566C20.5391 10.084 21.2266 9.74023 22 9.74023H24.75ZM13.75 9.74023C11.0859 9.74023 8.9375 7.5918 8.9375 4.92773C8.9375 2.30664 11.0859 0.115234 13.75 0.115234C16.3711 0.115234 18.5625 2.30664 18.5625 4.92773C18.5625 7.5918 16.3711 9.74023 13.75 9.74023ZM17.0156 11.1152C19.7656 11.1152 22 13.3496 22 16.0996V17.3027C22 18.4629 21.0547 19.3652 19.9375 19.3652H7.5625C6.40234 19.3652 5.5 18.4629 5.5 17.3027V16.0996C5.5 13.3496 7.69141 11.1152 10.4414 11.1152H10.7852C11.6875 11.5449 12.6758 11.8027 13.75 11.8027C14.7812 11.8027 15.7695 11.5449 16.6719 11.1152H17.0156ZM7.43359 10.5566C5.67188 11.502 4.46875 13.2207 4.16797 15.2402H1.375C0.601562 15.2402 0 14.6387 0 13.8652V12.4902C0 10.9863 1.20312 9.74023 2.75 9.74023H5.5C6.23047 9.74023 6.91797 10.084 7.43359 10.5566Z"
        fill="#0A0624"
      />
    </svg>
  );
}

export default People;
